<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.adaugaAdmin')}} </h4>
        </div>
        <form class="add-user-form" id="add-admin">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               v-bind:name="input_field.inputName"
                               v-bind:id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                       <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               :name="input_field.inputName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                            <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>

                <div class="col-12">
                    <div class="inner-location-group">
                        <div class="save-contact-buttons">
                            <button @click.prevent='addAdmin()' :disabled="this.$store.state.loading">
                                <i class="fas fa-check"></i>
                                {{$t('placeholder.salveaza')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import AdminsService from '../../api-services/admins.service.js'
export default {
  name: 'addadmin',
  data () {
    return {
      input_fields: {
        column_1: [
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: null,
            icon: 'fas fa-signature',
            validationRules: ''
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: null,
            icon: 'fas fa-signature',
            validationRules: ''
          }
        ],
        column_2: [
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: null,
            icon: 'fas fa-envelope',
            validationRules: 'email'
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: null,
            icon: 'fas fa-phone',
            validationRules: 'numeric'
          }
        ]
      }
    }
  },
  methods: {
    addAdmin () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('add-admin'))
      AdminsService.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.adminAdaugat'),
              'animation-type': 'css'
            })
            // var frm = document.getElementById('test-id')
            // alert(frm.offsetTop)
            window.scrollTo(0, 0)
            this.$router.push({ name: 'admins' })
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  computed: {},
  created () {
    this.$store.dispatch('hideLoading')
  }
}
</script>
